import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { DataTable } from '@/shared/components/data-table';
import type { Rock } from '../types';
import type { RockColumnDef, RockRenderContext } from '../hooks/useRockListTable';

interface RockListViewProps {
  sortedRocks: Rock[];
  visibleColumns: RockColumnDef[];
  columnFilters: Record<string, string>;
  ctx: RockRenderContext;
  sortKey: string;
  sortDirection: 1 | -1;
  isLoading?: boolean;
  onSort: (key: string) => void;
  onSetColumnFilter: (key: string, value: string) => void;
  onEditRock: (rock: Rock) => void;
  onSelectRock?: (rock: Rock) => void;
  onCreateRock?: () => void;
}

export function RockListView({
  sortedRocks,
  visibleColumns,
  columnFilters,
  ctx,
  sortKey,
  sortDirection,
  isLoading,
  onSort,
  onSetColumnFilter,
  onEditRock,
  onSelectRock,
  onCreateRock,
}: RockListViewProps) {
  return (
    <div className="space-y-2">
      <DataTable<Rock, RockRenderContext>
        items={sortedRocks}
        columns={visibleColumns}
        ctx={ctx}
        columnFilters={columnFilters}
        sortKey={sortKey}
        sortDirection={sortDirection}
        isLoading={isLoading}
        onSort={onSort}
        onSetColumnFilter={onSetColumnFilter}
        onRowClick={onSelectRock ?? onEditRock}
        emptyState={
          <>
            No rocks found.{' '}
            {onCreateRock && (
              <Button variant="link" size="sm" onClick={onCreateRock}>
                <Plus className="h-4 w-4 mr-1" />
                Add Rock
              </Button>
            )}
          </>
        }
      />
    </div>
  );
}
